import React from "react";

export default function SeasonTagFilter({ tag, setSeasonFilter, selected }) {

    return (
        <div
            className={selected ? "season_tag_filter_container_selected" : "season_tag_filter_container"}
            onClick={() => {
                setSeasonFilter(prev => (prev === tag ? "" : tag)); 
              }}
            key={tag}
        >
            <p>{tag}</p>
        </div>
    )
}